import { TOGGLE_SET_SIDEBAR_OPEN } from "./sidebarActionConstants";

export const toggleSetSidebarOpen = () => ({
  type: TOGGLE_SET_SIDEBAR_OPEN
});
